import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material'

function AvitoAutoloadGuideDialog({ open, onClose }) {
	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Как настроить автозагрузку в Авито</DialogTitle>
			<DialogContent>
				<Box component="ol" sx={{ pl: 3, my: 0 }}>
					<li>
						<Typography>Скопируйте ссылку автозагрузки в Reldo.</Typography>
					</li>
					<li>
						<Typography>
							Откройте настройки автозагрузки в кабинете Авито.
						</Typography>
					</li>
					<li>
						<Typography>Добавьте XML-фид по ссылке.</Typography>
					</li>
					<li>
						<Typography>Вставьте ссылку Reldo.</Typography>
					</li>
					<li>
						<Typography>Сохраните настройки.</Typography>
					</li>
				</Box>
				<Typography color="text.secondary" sx={{ mt: 2 }}>
					Reldo формирует данные для автозагрузки. Фактический статус
					публикации определяется Авито.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Готово</Button>
			</DialogActions>
		</Dialog>
	)
}

export default AvitoAutoloadGuideDialog
